import React from 'react';

const openStoryShare = (url: string, text: string) => {
  // eslint-disable-next-line no-undef
  if (window?.Kakao?.Story?.share) {
    window.Kakao.Story.share({ url, text });
  }
};

interface Props {
  url: string;
  device: any;
  text: string;
}
const KakaoStoryShareButton: React.FC<Props> = ({ url }) => {
  return (
    <button type="button" className="btn_sns btn_story" onClick={() => openStoryShare(url, '')}>
      <span className="ico_plus" />카카오스토리
    </button>
  );
};

export default KakaoStoryShareButton;

